module.exports = __webpack_public_path__ + "static/media/tb-icon.bb1e7500.png";